import ProposalClientTeamView from "work/proposals/_views/_shared/proposal-client-team-view";
import { useProposalClientTeamRoster } from "work/proposals/_views/_shared/use-proposal-client-team-roster";
import Proposal from "work/proposals/proposal";

export default function ActiveProposalClientTeamTab(props: {
  proposal: Proposal;
  negotiationId?: string;
  canEdit?: boolean;
  isDrawerOpen?: boolean;
}) {
  // The roster the page is holding for its Save, rather than a copy of it kept in this tab: the
  // tab is unmounted the moment the reader looks at another one, and a roster edit must survive
  // that the way every other tab's edits do (#5116).
  const roster = useProposalClientTeamRoster(props.negotiationId);

  // `showTemplates` is set here rather than defaulted inside the view, so that the surfaces which
  // only ever read this roster — the archived proposal, the hired work agreement — keep the
  // single-column page they have by saying nothing.
  return (
    <ProposalClientTeamView
      {...props}
      showTemplates
      members={roster?.members}
      hasUnsavedChanges={roster?.hasUnsavedChanges}
      changedElsewhereWhileEditing={roster?.changedElsewhereWhileEditing}
      onMembersChanged={roster?.stageMembers}
    />
  );
}
